import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { StickyContainer } from '@sparefoot/react-core';

import { Paragraph } from 'components/core/Typography';
import { Image } from 'components/core/Image';
import { SearchBox } from 'components/search/SearchBox';
import { Button } from 'components/core/Button';

import { Filter } from 'components/svg';
import mapToolBar from 'assets/images/map/map-tool-bar.svg';
import listIcon from 'assets/images/icons/list-icon-tool-bar.svg';
import MapPin from 'components/svg/MapPin';
import { simpleAmenityTextMap } from '../../../config/amenityMap';

import './SearchToolBar.scss';
import { toTitleCase } from '../../../utils/formatting';

export default function SearchToolBar({
	handleSearch,
	location,
	viewListMap,
	handleViewListMap,
	sticky,
	hidden,
	handleViewFilter,
	countFilter,
	vehicle,
	amenityType,
}) {
	const locationMessage = location
		? `${location.city}, ${location.state}`
		: 'Location Not Found';
	return React.createElement(
		sticky ? StickyContainer : Fragment,
		sticky ? { collapse: hidden } : undefined,
		<div className={classnames('tool-bar-search', { hidden })}>
			<div className="tool-bar-location-text">
				{!vehicle ? (
					<h1>
						Cheap {simpleAmenityTextMap[amenityType] || ''} Self
						Storage in&nbsp;
						<br />
						<span> {locationMessage} </span>
					</h1>
				) : (
					<h1>
						Cheap Self Storage for{' '}
						{vehicle && `${toTitleCase(vehicle)}s`} in&nbsp;
						<br />
						<span> {locationMessage} </span>
					</h1>
				)}
			</div>
			<div className="tool-bar-left">
				<div className="tool-bar-search-box">
					<SearchBox
						onSearch={handleSearch}
						icon={<MapPin fill="gray" />}
						id="tool-bar-search"
						inputLabel="Enter ZIP Code or City Name"
						hideAutocompleteOnScroll
						useBrowserLocation
					/>
				</div>
				<Paragraph
					color="white"
					size="small"
					weight="extraBold"
					last
					className="or-text"
				>
					OR
				</Paragraph>
				<Button
					className="tool-bar-button"
					type="button"
					onClick={handleViewListMap}
				>
					{viewListMap ? (
						<Fragment>
							<Image
								src={mapToolBar}
								alt="Map tool bar icon"
							/>
							<Paragraph
								color="white"
								size="small"
								weight="medium"
								last
							>
								View Map
							</Paragraph>
						</Fragment>
					) : (
						<Fragment>
							<Image src={listIcon} />
							<Paragraph
								color="white"
								size="small"
								weight="medium"
								last
							>
								View List
							</Paragraph>
						</Fragment>
					)}
				</Button>
				<Button
					className="tool-bar-button"
					type="button"
					onClick={handleViewFilter}
				>
					<Filter />
					<Paragraph
						color="white"
						size="small"
						weight="medium"
						last
					>
						View Filters
					</Paragraph>
					{countFilter > 0 && (
						<div className="count-filter-select">
							<Paragraph
								color="white"
								size="tiny"
								weight="extraBold"
								last
							>
								{countFilter}
							</Paragraph>
						</div>
					)}
				</Button>
			</div>
		</div>,
	);
}

SearchToolBar.propTypes = {
	handleSearch: PropTypes.func.isRequired,
	location: PropTypes.object,
	viewListMap: PropTypes.bool,
	handleViewListMap: PropTypes.func,
	sticky: PropTypes.bool,
	hidden: PropTypes.bool,
	handleViewFilter: PropTypes.func,
	countFilter: PropTypes.number,
	vehicle: PropTypes.string,
	amenityType: PropTypes.string,
};
